import { QUIENESSOMOS } from "../../interfaces/quienes-somos.interface";

export const quienesSomosJson: QUIENESSOMOS = {
    titleTxt: 'damos vida \n a los locales',
    oneColCarousel_items: [
        {
            "imgSrc": "assets/img/c3-img3.jpg",
            "imgAlt": "Foto RetailCo. #Retalk. Hablemos de dar vida a los locales.",
            "active": true
        },
        {
            "imgSrc": "assets/img/c3-img1.jpg",
            "imgAlt": "Foto RetailCo. #Retalk. Hablemos de dar vida a los locales.",
            "active": false
        },
        {
            "imgSrc": "assets/img/c3-img2.jpg",
            "imgAlt": "Foto RetailCo. #Retalk. Hablemos de dar vida a los locales.",
            "active": false
        }
    ],
    blockAreaQuienes_items: [
        {
            "title": "sobre \nnosotros",
            "titleNum": "01",
            "mainText1": "<p class='light'> Somos una gestora de inmuebles independiente. Participados al 100% por el Grupo Santander, en RetailCo centramos nuestra actividad principalmente en activos retail y de forma secundaria en otros inmuebles con potencial uso residencial, hotelero y oficinas. </p><p class='light'>Nuestra alma es joven y nuestro espíritu cuenta con experiencia profesional de reconocido prestigio en el sector inmobiliario, la consultoría estratégica y las finanzas. </p>"
        },
        {
            "title": "nuestra \nmisión",
            "titleNum": "02",
            "mainText1": "<p class='light'>Nacemos con una vocación patrimonialista para dar soluciones y poner en valor la cartera y los activos propiedad del Grupo Santander a través del arrendamiento, el cambio de uso, la transformación de los activos o la desinversión. </p><p class='light'>En nuestra filosofía está el buscar generar valor y crear un vehículo líder, sostenible, diversificado y rentable. Somos profesionales especialistas en la gestión, para sumar en el futuro del retail.</p><p class='light'>Nuestra fórmula de trabajo, nuestros protocolos, nuestro equipo y nuestro comité de dirección están planteados para generar la mayor de las garantías al proyecto y a la cartera de inmuebles gestionada.</p>"
        },
    ],
    imgTitle_params: {
        "imgSrc": 'assets/img/nuestros-valores.jpg',
        "imgAlt": 'Foto fondo surf RetailCo. #Retalk. Nuestros valores.',
        "title": 'nuestros \n valores',
        "num": '03'
    },
    oneColCarouselText_items: [
        {
            "imgSrc": "assets/img/c4-img1.jpg",
            "imgAlt": "Foto Nuestros valores. Agilidad",
            "text": "Agilidad",
            "active": true
        },
        {
            "imgSrc": "assets/img/c4-img2.jpg",
            "imgAlt": "Foto Nuestros valores. Creatividad",
            "text": "Creatividad",
            "active": false
        },
        {
            "imgSrc": "assets/img/c4-img3.jpg",
            "imgAlt": "Foto Nuestros valores. Market Value",
            "text": "Market Value",
            "active": false
        },
        {
            "imgSrc": "assets/img/c4-img4.jpg",
            "imgAlt": "Foto Nuestros valores. Profesionalización",
            "text": "Profesionalización",
            "active": false
        }
    ],
    phrasesQuienesSomos_items: [
        {
            "title": "Profesionalización",
            "phrase": "Equipo muy especializado y cualificado a nivel inmobiliario y financiero con quien interactuar"
        },
        {
            "title": "Creatividad",
            "phrase": "Capacidad creativa para estructurar acuerdos, financiar proyectos y proponer soluciones"
        },
        {
            "title": "Agilidad",
            "phrase": "Gestión ágil y eficaz gracias a los procedimientos y la tecnología"
        },
        {
            "title": "Market value",
            "phrase": "Respeto a los valores de mercado buscando un vehículo sano en términos de renta y tasas de esfuerzo"
        }
    ],
    ParallaxQuienesSomos_props: {
        "title": "nuestra \n visión",
        "titleNum": "04"
    },
    twoColAreaNoButtonParams: {
        "twoColArea_preTitle": "NUESTRA VISIÓN",
        "twoColArea_title": "nuevas formas de alquilar, de estar, de poblar, de habitar.",
        "twoColArea_mainText": "Nuestra visión es fomentar el desarrollo inmobiliario a través de nuestros activos. Dotándoles de valor, vamos a dar vida a las ciudades, activar nuestras calles, sumar potencial a la actividad empresarial y económica de los barrios y de sus gentes."
    }
}